import PropTypes from 'prop-types';
import { Header, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import BrandBubble from '../LogoBubble';
import styles from './FeaturedGasBackBrands.module.css';

const cx = classnames.bind(styles);

export default function FeaturedGasBackBrands({ className, brands, ...rest }) {
  return (
    <div className={cx('container', className)} {...rest}>
      <Text centered>
        <Header as="h2">Get GasBack from brands you already trust.</Header>
        <Text as="p" className={cx('text')}>You already shop at these brands, so why not earn free gas when you do? GasBack is free money for gas earned from everyday purchases. Earning GasBack is easy and it&apos;s automatically applied at the pump at gas stations nationwide.</Text>
        <div className={cx('brands')}>
          {brands.map(({ title, logo }) => (
            <BrandBubble className={cx('bubble')} key={logo} logoUrl={logo} title={title} />
          ))}
        </div>
      </Text>
    </div>
  );
}

FeaturedGasBackBrands.propTypes = {
  className: PropTypes.string,
  brands: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    logo: PropTypes.string,
  })),
};

FeaturedGasBackBrands.defaultProps = {
  className: undefined,
  brands: [],
};
